import { render, staticRenderFns } from "./JayAlert.vue?vue&type=template&id=27084770&scoped=true"
import script from "./JayAlert.vue?vue&type=script&lang=js"
export * from "./JayAlert.vue?vue&type=script&lang=js"
import style0 from "./JayAlert.vue?vue&type=style&index=0&id=27084770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27084770",
  null
  
)

export default component.exports